export const AppRoutes = {
  AUTH: {
    LOGIN: '/authentication/login',
    REGISTER: '/authentication/register',
    RESET_PASSWORD: '/authentication/reset-password',
  },
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  ADMIN: {
    HOME: '/admin/home',
    USERS: '/admin/users',
  }
};
